/** @format */

/* eslint react-hooks/rules-of-hooks: "warn" */
import React, { Fragment, ReactNode } from 'react';

import { MetaFactory } from '@toucan/services/factories/meta';

import { useMounted } from '@toucan/client/shared/hooks/use-mounted';

type GetMetaElementsProps = {
    factory: MetaFactory;
    /**
     * Ignore the mounted check - useful for SSR pages that should add meta elements on the first render
     */
    ignoreMount?: boolean;
};

export const getMetaElements = ({
    factory,
    ignoreMount = false,
}: GetMetaElementsProps): ReactNode => {
    const mounted = useMounted();

    function getMeta(): ReactNode {
        if (!mounted() && !ignoreMount) {
            return null;
        }

        const { title, description } = factory.getMeta();

        return (
            <Fragment>
                <title data-testid="head__page-title">{title}</title>
                <meta
                    name="description"
                    data-testid="head__page-description"
                    content={description}
                />
            </Fragment>
        );
    }

    return getMeta();
};
